module.exports = __webpack_public_path__ + "staticmedia/media/Roboto-Medium.e8b5e2b2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fonts/Roboto-Medium.ttf
// module id = 75
// module chunks = 0